import { IconPropsType } from './types/IconsProps.type';

type CheckIconProps = IconPropsType 

export const CheckIcon = ({
  width = 32,
  height = 32,
  className = '',
  style = {},
  fillColor = 'currentColor',
}: CheckIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M28.4444 0H3.55556C1.58222 0 0 1.6 0 3.55556V28.4444C0 30.4 1.58222 32 3.55556 32H28.4444C30.4178 32 32 30.4 32 28.4444V3.55556C32 1.6 30.4178 0 28.4444 0ZM12.4444 24.8889L3.55556 16L6.06222 13.4933L12.4444 19.8578L25.9378 6.36444L28.4444 8.88889L12.4444 24.8889Z"
        fill={fillColor}
      />
    </svg>
  );
};
